export default __webpack_public_path__ + "static/qa-a0b7c3835f83b6f9713f178c79879373.png";